import React from "react"
import { ExtratoPagarmeFornecedorContextProvider } from "./context/ExtratoPagarmeFornecedorContextProvider"
import { ExtratoPagarmeFornecedor } from "./ExtratoPagarmeFornecedor"

export function Index() {
    return (
        <ExtratoPagarmeFornecedorContextProvider>
            <ExtratoPagarmeFornecedor />
        </ExtratoPagarmeFornecedorContextProvider>
    )
}
